export default "__VITE_ASSET__m33b8q8Q__"